import {Field, reduxForm, SubmissionError} from 'redux-form';
import {Button, Form, Message, Segment} from 'semantic-ui-react';
import {FormInput, mobile} from '../shared/forms';
import {required} from '../shared/forms/validations';

function MobileForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;
  return (
    <Segment>
      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null, props))}>
        <Field
          required
          name='mobile'
          label='شماره تلفن همراه'
          component={FormInput}
          validate={[required, mobile]}
        />
        <Button
          type='submit'
          disabled={pristine || submitting}
          content='تایید'
        />
      </Form>
    </Segment>
  );
}

async function submit(props, {mobile}) {
  try {
    await props.onSubmit(mobile);
  } catch (error) {
    if (error.data && error.data.hasOwnProperty('mobile')) {
      throw new SubmissionError({'mobile': error.data.mobile});
    }
    const errorMessage = error.message || 'شماره وارد شده تکراری است.';
    throw new SubmissionError({_error: errorMessage});
  }
}

export default reduxForm({form: 'register-mobile'})(MobileForm);
